"use strict";

var cov_12gk3nuznl = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\OriginalWordObject.js";
  var hash = "046f0cfc6236b547a833cc788dd03bc89c7f9fd5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\OriginalWordObject.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 31
        }
      },
      "1": {
        start: {
          line: 19,
          column: 17
        },
        end: {
          line: 19,
          column: 63
        }
      },
      "2": {
        start: {
          line: 20,
          column: 18
        },
        end: {
          line: 20,
          column: 67
        }
      },
      "3": {
        start: {
          line: 21,
          column: 17
        },
        end: {
          line: 21,
          column: 63
        }
      },
      "4": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 29,
          column: 4
        }
      },
      "5": {
        start: {
          line: 32,
          column: 0
        },
        end: {
          line: 44,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "OriginalWordObject",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 27
          }
        },
        loc: {
          start: {
            line: 16,
            column: 3
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 20
          }
        }, {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 31
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 17
          },
          end: {
            line: 19,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 58
          }
        }, {
          start: {
            line: 19,
            column: 61
          },
          end: {
            line: 19,
            column: 63
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 18
          },
          end: {
            line: 20,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 62
          }
        }, {
          start: {
            line: 20,
            column: 65
          },
          end: {
            line: 20,
            column: 67
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 21,
            column: 17
          },
          end: {
            line: 21,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 21,
            column: 58
          }
        }, {
          start: {
            line: 21,
            column: 61
          },
          end: {
            line: 21,
            column: 63
          }
        }],
        line: 21
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "046f0cfc6236b547a833cc788dd03bc89c7f9fd5"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function OriginalWordObject(_ref) {
  var verseObject = _ref.verseObject,
      _ref$verseObject = _ref.verseObject,
      content = _ref$verseObject.content,
      text = _ref$verseObject.text,
      strong = _ref$verseObject.strong,
      lemma = _ref$verseObject.lemma,
      morph = _ref$verseObject.morph;
  cov_12gk3nuznl.f[0]++;

  var _text = (cov_12gk3nuznl.s[0]++, (cov_12gk3nuznl.b[0][0]++, text) || (cov_12gk3nuznl.b[0][1]++, content));

  var _lemma = (cov_12gk3nuznl.s[1]++, lemma ? (cov_12gk3nuznl.b[1][0]++, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("br", null), _react.default.createElement("em", null, "lemma:"), " ", lemma)) : (cov_12gk3nuznl.b[1][1]++, ''));

  var _strong = (cov_12gk3nuznl.s[2]++, strong ? (cov_12gk3nuznl.b[2][0]++, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("br", null), _react.default.createElement("em", null, "strong:"), " ", strong)) : (cov_12gk3nuznl.b[2][1]++, ''));

  var _morph = (cov_12gk3nuznl.s[3]++, morph ? (cov_12gk3nuznl.b[3][0]++, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("br", null), _react.default.createElement("em", null, "morph:"), " ", morph)) : (cov_12gk3nuznl.b[3][1]++, ''));

  cov_12gk3nuznl.s[4]++;
  return _react.default.createElement(_core.Typography, null, _react.default.createElement("strong", null, _text), _lemma, _strong, _morph);
}

;
cov_12gk3nuznl.s[5]++;
OriginalWordObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string,
    children: _propTypes.default.arrayOf(_propTypes.default.object),
    strong: _propTypes.default.string,
    lemma: _propTypes.default.string,
    morph: _propTypes.default.string,
    occurrence: _propTypes.default.string,
    occurrences: _propTypes.default.string
  }).isRequired
};
var _default = OriginalWordObject;
exports.default = _default;